import { collection, addDoc } from '@battleops/localstore';
import { db } from './store';
import { localToday } from '@battleops/shared';

// Behavioral telemetry — records skip/switch transitions between task cards (dwell time, from/to
// task + project, session). Fire-and-forget: it feeds the future "Up Next" behavior ranker and must
// never block or break the task flow. Firestore rules are open (single-user app), so this is a
// best-effort append to `taskFlow`; there is no read path yet (data accumulates for later use).
export function logTaskTransition(event) {
  try {
    const payload = {
      ...event,
      at: Date.now(),
      date: localToday(),
    };
    addDoc(collection(db, 'taskFlow'), payload).catch(() => {});
  } catch {
    // swallow — telemetry is never allowed to surface as a user-facing error
  }
}
